import {Platform} from "@angular/cdk/platform";
import {Injectable} from "@angular/core";

@Injectable()
export class MapsService {
  constructor(private platform: Platform) {
  }

  getDirectionsLink(lat: string, lon: string) {
    if (this.platform.IOS) {
      return `http://maps.apple.com/?daddr=${lat}%2C${lon}&dirflg=d&t=m`;
    } else {
      return `https://www.google.com/maps/dir/?api=1&destination=${lat}%2C${lon}&travelmode=driving`;
    }
  }
}


// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/maps.service.ts